import { NavLink, Navigate, Outlet } from "react-router-dom";
import {
  Building,
  Building2,
  DatabaseZap,
  Inbox,
  Layers,
  Leaf,
  ListChecks,
  Mail,
  ShieldCheck,
  Users,
} from "lucide-react";
import { hasAnyRole, useAuth } from "../../auth";
import { Card, PageHeader, cx } from "../../ui";

export function AdminLayout() {
  const { state } = useAuth();
  if (state.status !== "authenticated") {
    return <Navigate to="/login" replace />;
  }
  if (!hasAnyRole(state.me, ["property_manager", "admin"])) {
    return (
      <div>
        <PageHeader title="Admin" />
        <Card>
          <p className="text-ink-500">
            Only Property Management and Administrators can access this area.
          </p>
        </Card>
      </div>
    );
  }
  return (
    <div>
      <PageHeader
        title="Admin"
        subtitle="Configure the building, projects, and access. Changes take effect immediately and are recorded in the audit log."
      />
      <nav className="flex gap-1 mb-5 overflow-x-auto -mx-1 px-1">
        <Tab to="/admin/buildings" icon={<Building size={16} />}>
          Buildings
        </Tab>
        <Tab to="/admin/users" icon={<Users size={16} />}>
          Users
        </Tab>
        <Tab to="/admin/units" icon={<Building2 size={16} />}>
          Units
        </Tab>
        <Tab to="/admin/risers" icon={<Layers size={16} />}>
          Risers
        </Tab>
        <Tab to="/admin/project-types" icon={<ListChecks size={16} />}>
          Project types
        </Tab>
        <Tab to="/admin/invites" icon={<Mail size={16} />}>
          Invites
        </Tab>
        <Tab to="/admin/claims" icon={<Inbox size={16} />}>
          Unit claims
        </Tab>
        <Tab to="/admin/insurance-review" icon={<ShieldCheck size={16} />}>
          Insurance
        </Tab>
        {hasAnyRole(state.me, ["admin"]) && (
          <>
            <Tab
              to="/admin/contractor-import"
              icon={<DatabaseZap size={16} />}
            >
              Contractor import
            </Tab>
            <Tab to="/admin/elm-metrics" icon={<Leaf size={16} />}>
              Elm metrics
            </Tab>
          </>
        )}
      </nav>
      <Outlet />
    </div>
  );
}

function Tab({
  to,
  icon,
  children,
}: {
  to: string;
  icon: React.ReactNode;
  children: React.ReactNode;
}) {
  return (
    <NavLink
      to={to}
      end={false}
      className={({ isActive }) =>
        cx(
          "inline-flex items-center gap-1.5 px-3.5 py-2 rounded-md text-[13px] font-medium whitespace-nowrap no-underline hover:no-underline transition-colors",
          isActive
            ? "bg-white text-brand-700 border border-brand-200 shadow-soft"
            : "bg-transparent text-ink-600 hover:text-ink-800 hover:bg-white border border-transparent",
        )
      }
    >
      {icon}
      {children}
    </NavLink>
  );
}
